import WorkOrdersListLayout from './WorkOrdersListLayout'

export default WorkOrdersListLayout
